<template>
	<div>
		<div class="page_header">
			<span class="page_title">{{$t("driver.badDriving")}}</span>
			<quickQuery :speedShow="false" @handleQuery="handleQuery" @quickQuery="quickQuery" @download="download"
				style="flex:1;text-align: right" />
		</div>
		<div class="page_container_a">
			<el-table :size="size" v-loading="loading" :data="tableData" border ref="driverTable" height="382"
				style="width: 100%;" highlight-current-row @current-change="handleCurrentChange">
				<!-- <el-table-column type="index" align="center" width="105" :label='$t("public.OrderIndex")' fixed>
				</el-table-column> -->
				<el-table-column prop="carNo" align="center" width="130" :label='$t("vehicle.carNo")' fixed>
				</el-table-column>
				<el-table-column prop="speeding" align="center" width="100"
					:label='$t("driver.speeding")+$t("driver.order")'>
					<template slot-scope="scope">{{inEmpty(scope.row.speeding)}}</template>
				</el-table-column>
				<el-table-column prop="speeding_time" align="center" width="110" :label='$t("driver.speeding_time")'>
					<template slot-scope="scope">{{timeChange(scope.row.speeding_time)}}</template>
				</el-table-column>
				<el-table-column prop="speeding_proportion" align="center" width="120"
					:label='$t("driver.speeding_proportion")'>
					<template slot-scope="scope">{{toPercentage(scope.row.speeding_proportion)}}</template>
				</el-table-column>
				<el-table-column prop="idleAirConditioning" align="center" width="100"
					:label='$t("driver.idleAirConditioning")+$t("driver.order")'>
					<template slot-scope="scope">{{inEmpty(scope.row.idleAirConditioning)}}</template>
				</el-table-column>
				<el-table-column prop="idleAirConditioning_time" align="center" width="110"
					:label='$t("driver.idleAirConditioning_time")'>
					<template slot-scope="scope">{{timeChange(scope.row.idleAirConditioning_time)}}</template>
				</el-table-column>
				<el-table-column prop="idleAirConditioning_proportion" align="center" width="120"
					:label='$t("driver.idleAirConditioning_proportion")'>
					<!-- <template slot-scope="scope">{{(scope.row.idleAirConditioning_proportion)}}</template> -->
					<template slot-scope="scope">{{toPercentage(scope.row.idleAirConditioning_proportion)}}</template>
				</el-table-column>
				<!-- <el-table-column prop="secondGearStarting" align="center" width="100"   :label='$t("driver.secondGearStarting")+$t("driver.order")'> </el-table-column>
                <el-table-column prop="secondGearStarting_time" align="center" width="100"   :label='$t("driver.secondGearStarting_time")'> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="120"  :label='$t("driver.secondGearStarting_proportion")'> </el-table-column> -->
				<el-table-column prop="engineOverturning" align="center" width="110"
					:label='$t("driver.engineOverturning")+$t("driver.order")'>
					<template slot-scope="scope">{{inEmpty(scope.row.engineOverturning)}}</template>
				</el-table-column>
				<el-table-column prop="engineOverturning_time" align="center" width="110"
					:label='$t("driver.engineOverturning_time")'>
					<template slot-scope="scope">{{timeChange(scope.row.engineOverturning_time)}}</template>
				</el-table-column>
				<el-table-column prop="engineOverturning_proportion" align="center" width="130"
					:label='$t("driver.engineOverturning_proportion")'>
					<template slot-scope="scope">{{toPercentage(scope.row.engineOverturning_proportion)}}</template>
				</el-table-column>
				<el-table-column prop="excessiveIdleSpeed" align="center" width="100"
					:label='$t("driver.excessiveIdleSpeed")+$t("driver.order")'>
					<template slot-scope="scope">{{inEmpty(scope.row.excessiveIdleSpeed)}}</template>
				</el-table-column>
				<el-table-column prop="excessiveIdleSpeed_time" align="center" width="125"
					:label='$t("driver.excessiveIdleSpeed_time")'>
					<template slot-scope="scope">{{timeChange(scope.row.excessiveIdleSpeed_time)}}</template>
				</el-table-column>
				<el-table-column prop="excessiveIdleSpeed_proportion" align="center" width="120"
					:label='$t("driver.excessiveIdleSpeed_proportion")'>
					<template slot-scope="scope">{{toPercentage(scope.row.excessiveIdleSpeed_proportion)}}</template>
				</el-table-column>
				<el-table-column prop="rapidAcceleration" align="center" width="100"
					:label='$t("driver.rapidAcceleration")+$t("driver.order")'>
					<template slot-scope="scope">{{inEmpty(scope.row.rapidAcceleration)}}</template>
				</el-table-column>
				<el-table-column prop="rapidAcceleration_time" align="center" width="110"
					:label='$t("driver.rapidAcceleration_time")'>
					<template slot-scope="scope">{{timeChange(scope.row.rapidAcceleration_time)}}</template>
				</el-table-column>
				<el-table-column prop="rapidAcceleration_proportion" align="center" width="120"
					:label='$t("driver.rapidAcceleration_proportion")'>
					<template slot-scope="scope">{{toPercentage(scope.row.rapidAcceleration_proportion)}}</template>
				</el-table-column>
				<el-table-column prop="rapidDeceleration" align="center" width="100"
					:label='$t("driver.rapidDeceleration")+$t("driver.order")'>
					<template slot-scope="scope">{{inEmpty(scope.row.rapidDeceleration)}}</template>
				</el-table-column>
				<el-table-column prop="rapidDeceleration_time" align="center" width="110"
					:label='$t("driver.rapidDeceleration_time")'>
					<template slot-scope="scope">{{timeChange(scope.row.rapidDeceleration_time)}}</template>
				</el-table-column>
				<el-table-column prop="rapidDeceleration_proportion" align="center" width="120"
					:label='$t("driver.rapidDeceleration_proportion")'>
					<template slot-scope="scope">{{toPercentage(scope.row.rapidDeceleration_proportion)}}</template>
				</el-table-column>
				<el-table-column prop="coasting" align="center" width="100"
					:label='$t("driver.coasting")+$t("driver.order")'>
					<template slot-scope="scope">{{inEmpty(scope.row.coasting)}}</template>
				</el-table-column>
				<el-table-column prop="coasting_time" align="center" width="110" :label='$t("driver.coasting_time")'>
					<template slot-scope="scope">{{timeChange(scope.row.coasting_time)}}</template>
				</el-table-column>
				<el-table-column prop="coasting_proportion" align="center" width="120"
					:label='$t("driver.coasting_proportion")'>
					<template slot-scope="scope">{{toPercentage(scope.row.coasting_proportion)}}</template>
				</el-table-column>
				<!-- <el-table-column prop="coldDriving" align="center" width="100"   :label='$t("driver.coldDriving")+$t("driver.order")'> </el-table-column>
                <el-table-column prop="coldDriving_time" align="center" width="100"   :label='$t("driver.coldDriving_time")'> </el-table-column>
                <el-table-column prop="coldDriving_proportion" align="center" width="120"   :label='$t("driver.coldDriving_proportion")'> </el-table-column> -->
				<!-- <el-table-column prop="clutchLinkage" align="center"  width="130"  :label='$t("driver.clutchLinkage")+$t("driver.order")'> </el-table-column>
                <el-table-column prop="clutchLinkage_time" align="center"  width="130"  :label='$t("driver.clutchLinkage_time")'> </el-table-column>
                <el-table-column prop="clutchLinkage_proportion" align="center"  width="150"  :label='$t("driver.clutchLinkage_proportion")'> </el-table-column> -->
				<el-table-column prop="fatigueDriving" align="center" width="100"
					:label='$t("driver.fatigueDriving")+$t("driver.order")'>
					<template slot-scope="scope">{{inEmpty(scope.row.fatigueDriving)}}</template>
				</el-table-column>
				<el-table-column prop="fatigueDriving_time" align="center" width="110"
					:label='$t("driver.fatigueDriving_time")'>
					<template slot-scope="scope">{{timeChange(scope.row.fatigueDriving_time)}}</template>
				</el-table-column>
				<el-table-column prop="fatigueDriving_proportion" align="center" width="120"
					:label='$t("driver.fatigueDriving_proportion")'>
					<template slot-scope="scope">{{toPercentage(scope.row.fatigueDriving_proportion)}}</template>
				</el-table-column>
				<!-- <el-table-column prop="dragGear" align="center" width="90" :label='$t("driver.dragGear")+$t("driver.order")'> </el-table-column>
                <el-table-column prop="dragGear_time" align="center" width="90" :label='$t("driver.dragGear_time")'> </el-table-column>
                <el-table-column prop="dragGear_proportion" align="center" width="100" :label='$t("driver.dragGear_proportion")'> </el-table-column> -->

				<!-- <el-table-column prop="secondGearStarting_proportion" align="center" width="100"  label="打哈欠(次)"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="100"  label="打哈欠时间"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="120"  label="打哈欠时间占比"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="100"  label="左顾右盼(次)"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="100"  label="左顾右盼时间"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="120"  label="左顾右盼时间占比"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="100"  label="抽烟(次)"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="100"  label="抽烟时间"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="100"  label="抽烟时间占比"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="100"  label="打手机(次)"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="100"  label="打手机时间"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="120"  label="打手机时间占比"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="140"  label="驾驶员坐姿不规范(次)"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="150"  label="驾驶员坐姿不规范时间"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="170"  label="驾驶员坐姿不规范时间占比"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="120"  label="疲劳驾驶闭眼(次)"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="120"  label="疲劳驾驶闭眼时间"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="150"  label="疲劳驾驶闭眼时间占比"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="100"  label="行人报警(次)"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="100"  label="行人报警时间"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="120"  label="行人报警时间占比"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="130"  label="左倒车后方穿行(次)"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="130"  label="左倒车后方穿行时间"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="160"  label="左倒车后方穿行时间占比"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="130"  label="右倒车后方穿行(次)"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="130"  label="右倒车后方穿行时间"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="160"  label="右倒车后方穿行时间占比"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="130"  label="左侧方盲区报警(次)"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="130"  label="左侧方盲区报警时间"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="160"  label="左侧方盲区报警时间占比"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="130"  label="右侧方盲区报警(次)"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="130"  label="右侧方盲区报警时间"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="160"  label="右侧方盲区报警时间占比"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="110"  label="左开门报警(次)"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="110"  label="左开门报警时间"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="130"  label="左开门报警时间占比"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="110"  label="右开门报警(次)"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="110"  label="右开门报警时间"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="130"  label="右开门报警时间占比"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="100"  label="车道左偏(次)"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="100"  label="车道左偏时间"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="120"  label="车道左偏时间占比"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="100"  label="车道右偏(次)"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="100"  label="车道右偏时间"> </el-table-column>
                <el-table-column prop="secondGearStarting_proportion" align="center" width="120"  label="车道右偏时间占比"> </el-table-column> -->

			</el-table>

			<kl-pagination style="margin-bottom: 10px;" v-show="total > 0" :total="total" @current-change="pageChange"
				:current-page.sync="PageNo">
			</kl-pagination>
			<div class="chart-container">
				<div
					style="background-color:#E8F0FF;height:30px;width:100%;display: flex;align-items: center;font-size:14px;margin-bottom:8px;">
					<span style="font-weight:bold;padding: 0 25px;">{{carNo}}</span>
					<span style="">{{$t("driver.selectBadDriRecord")}}</span>
					<span><span :style="getTitlePadding">{{form.beginDate}} 00:00:00</span>{{$t("time.to")}}<span
							:style="getTitlePadding">{{form.endDate}} 23:59:59</span></span>
				</div>
				<el-row>
					<el-col :span="12">
						<div id="driverChartByFrequency" style="width:100%;height:275px"></div>
					</el-col>
					<el-col :span="11">
						<div id="driverChartByTime" style="width: 100%;height: 275px;"></div>
					</el-col>
				</el-row>
			</div>
		</div>


	</div>
</template>
<script>
	// import * as echarts from "echarts"
	import {
		mapState
	} from 'vuex'
	import quickQuery from '../../statistics/components/generalOrQuickQuery.vue'
	export default {
		name:"nonDriver",
		components: {
			quickQuery
		},
		data() {
			return {
				loading: false,
				tableData: [],
				total: 0,
				PageNo: 1,
				pageSize: 10,
				form: {
					beginDate: "",
					endDate: "",
				},
				carNo: "",
				driverChartByTime: undefined,
				driverChartByFrequency: undefined,
				vehicles: "",
				allVehicles: "",
				autoWidth: true
			}
		},
		computed: {
			...mapState({
				opened: state => state.app.sidebar.opened,
				selectedVehicles: state => state.app.vehicles.selectedVehicles,
				appVehicles: state => state.app.vehicles,
			}),
			getTitlePadding() {
				if (this.form.beginDate == "" && this.form.endDate == "") {
					return "padding: 0 20px"
				}
				return "padding: 0 15px"
			},
			size() {
				return this.$store.getters.size
			},
			operator() {
				return this.$store.getters.operator
			},
		},
		watch: {
			opened() {
				setTimeout(() => {
					this.driverChartByTime.resize();
					this.driverChartByFrequency.resize();
				}, 300)
			},
		},
		methods: {
			inEmpty(row) {
				return row == null ? 0 : row;
			},
			timeChange(s) {
				if (s == null) return "00:00:00";
				let hour, minute, second;
				hour = parseInt(s / 3600);
				minute = parseInt(s / 60 % 60);
				second = parseInt(s % 60);
				// console.log(s,hour,minute,second,);
				return (hour < 10 ? "0" + hour : hour) + ":" + (minute < 10 ? "0" + minute : minute) + ":" + (second < 10 ?
					"0" + second : second);

			},
			toPercentage(val) {
				if (val == null) return 0;
				val = (val * 100).toFixed(2);
				if (val == 0.00) return 0;
				return val + "%";
			},
			//添加按次数饼图数据
			pushChartsDateByFrequency(row) {
				var pieDataByFrequency = [];
				// pieDataByFrequency.push({name:"超速行驶",value:row.speeding})
				// pieDataByFrequency.push({name:"怠速空调",value:row.idleAirConditioning})
				// pieDataByFrequency.push({name:"二档起步",value:row.secondGearStarting})
				// pieDataByFrequency.push({name:"发动机超转",value:row.engineOverturning})
				// pieDataByFrequency.push({name:"过长怠速",value:row.excessiveIdleSpeed})
				// pieDataByFrequency.push({name:"急加速",value:row.rapidAcceleration})
				// pieDataByFrequency.push({name:"急减速",value:row.rapidDeceleration})
				// pieDataByFrequency.push({name:"空挡滑行",value:row.coasting})
				// pieDataByFrequency.push({name:"冷车驾驶",value:row.coldDriving})
				// pieDataByFrequency.push({name:"离合器半联动",value:row.clutchLinkage})
				// pieDataByFrequency.push({name:"疲劳驾驶",value:row.fatigueDriving})
				// pieDataByFrequency.push({name:"拖挡",value:row.dragGear})
				pieDataByFrequency.push({
					name: this.$t("driver.speeding"),
					value: row.speeding == null ? 0 : row.speeding
				})
				pieDataByFrequency.push({
					name: this.$t("driver.idleAirConditioning"),
					value: row.idleAirConditioning == null ? 0 : row.idleAirConditioning
				})
				pieDataByFrequency.push({
					name: this.$t("driver.engineOverturning"),
					value: row.engineOverturning == null ? 0 : row.engineOverturning
				})
				pieDataByFrequency.push({
					name: this.$t("driver.excessiveIdleSpeed"),
					value: row.excessiveIdleSpeed == null ? 0 : row.excessiveIdleSpeed
				})
				pieDataByFrequency.push({
					name: this.$t("driver.rapidAcceleration"),
					value: row.rapidAcceleration == null ? 0 : row.rapidAcceleration
				})
				pieDataByFrequency.push({
					name: this.$t("driver.rapidDeceleration"),
					value: row.rapidDeceleration == null ? 0 : row.rapidDeceleration
				})
				pieDataByFrequency.push({
					name: this.$t("driver.coasting"),
					value: row.coasting == null ? 0 : row.coasting
				})
				pieDataByFrequency.push({
					name: this.$t("driver.coldDriving"),
					value: row.coldDriving == null ? 0 : row.coldDriving
				})
				// pieDataByFrequency.push({name:this.$t("driver.clutchLinkage"),value:row.clutchLinkage})
				pieDataByFrequency.push({
					name: this.$t("driver.fatigueDriving"),
					value: row.fatigueDriving == null ? 0 : row.fatigueDriving
				})
				// pieDataByFrequency.push({name:this.$t("driver.dragGear"),value:row.dragGear})
				// pieDataByFrequency.push({name:this.$t("driver.secondGearStarting"),value:row.secondGearStarting})
				this.driverChartByFrequency.setOption({
					series: [{
						type: 'pie',
						radius: '50%',
						avoidLabelOverlap: true,
						data: pieDataByFrequency,
					}]
				})
			},
			//添加按时间饼图数据
			pushChartsDateByTime(row) {
				var pieDataByTime = [];
				pieDataByTime.push({
					name: this.$t("driver.speeding"),
					value: row.speeding_time == null ? 0 : row.speeding_time
				})
				pieDataByTime.push({
					name: this.$t("driver.idleAirConditioning"),
					value: row.idleAirConditioning_time == null ? 0 : row.idleAirConditioning_time
				})
				pieDataByTime.push({
					name: this.$t("driver.engineOverturning"),
					value: row.engineOverturning_time == null ? 0 : row.engineOverturning_time
				})
				pieDataByTime.push({
					name: this.$t("driver.excessiveIdleSpeed"),
					value: row.excessiveIdleSpeed_time == null ? 0 : row.excessiveIdleSpeed_time
				})
				pieDataByTime.push({
					name: this.$t("driver.rapidAcceleration"),
					value: row.rapidAcceleration_time == null ? 0 : row.rapidAcceleration_time
				})
				pieDataByTime.push({
					name: this.$t("driver.rapidDeceleration"),
					value: row.rapidDeceleration_time == null ? 0 : row.rapidDeceleration_time
				})
				pieDataByTime.push({
					name: this.$t("driver.coasting"),
					value: row.coasting_time == null ? 0 : row.coasting_time
				})
				pieDataByTime.push({
					name: this.$t("driver.coldDriving"),
					value: row.coldDriving_time == null ? 0 : row.coldDriving_time
				})
				// pieDataByTime.push({name:this.$t("driver.clutchLinkage"),value:row.clutchLinkage_time})
				pieDataByTime.push({
					name: this.$t("driver.fatigueDriving"),
					value: row.fatigueDriving_time == null ? 0 : row.fatigueDriving_time
				})
				// pieDataByTime.push({name:this.$t("driver.dragGear"),value:row.dragGear_time})
				// pieDataByTime.push({name:this.$t("driver.secondGearStarting"),value:row.secondGearStarting_time})
				this.driverChartByTime.setOption({
					series: [{
						type: 'pie',
						radius: '50%',
						avoidLabelOverlap: true,
						tooltip: {
							valueFormatter: (value)=> {
								return this.timeChange(value);
							},
						},
						data: pieDataByTime,
					}]
				})
			},
			pageChange(page) {
				this.PageNo = page;
				this.getList();
			},
			handleCurrentChange(row) {
				if (row == null) return;
				this.carNo = row.carNo;
				this.pushChartsDateByFrequency(row);
				this.pushChartsDateByTime(row);
			},
			getSelectedVehicles() {
				this.vehicles = "";
				for (let k = 0; k < this.selectedVehicles.length; k++) {
					if (this.selectedVehicles[k].treeLevel == 5) {
						this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
					}
				}
				return this.vehicles.substring(0, this.vehicles.length - 1);
			},
			handleQuery(val) {
				this.form = val;

				this.vehicles = this.getSelectedVehicles();
				this.PageNo = 1;
				this.getList();
			},
			quickQuery(val, btn) {
				this.showBtn = btn;
				this.form = val;

				this.vehicles = this.getSelectedVehicles();
				this.PageNo = 1;
				this.getList();
			},
			getList() {
				this.loading = true;
				this.$api
					.driver({
						optID: this.$store.getters.operator.OperatorId,
						vehicles: this.vehicles == "" ? this.allVehicles : this.vehicles,
						beginDate: this.form.beginDate, //"2023-08-01",
						endDate: this.form.endDate, //"2023-08-24",
						PageSize: this.PageSize,
						PageNo: this.PageNo,
					})
					.then((res) => {
						if (res && res.code == 200) {
							this.tableData = res.data;
							this.total = res.recordsTotal;
							this.loading = false;

							this.$refs.driverTable.setCurrentRow(this.tableData[0]);
							this.carNo = this.tableData[0].carNo;

							if (this.total == 0) {
								this.$message.info(this.$t("statistics.noData"));
							}
						}
					})
					.catch((e) => {
						this.loading = false;
					})
			},
			download() {
				if (this.total > 0) {
					this.$api
						.driver({
							optID: this.$store.getters.operator.OperatorId,
							vehicles: this.vehicles == "" ? this.allVehicles : this.vehicles,
							beginDate: this.form.beginDate,
							endDate: this.form.endDate,
							PageNo: 1,
							PageSize: this.total,
						})
						.then((res) => {
							if (res && res.code == 200) {
								//换一种导出 
								var fileName = this.$t("driver.badDriving") + this.$t("public.download");
								import('../../statistics/components/Export2Excel').then(excel => {
									const tHeader = [this.$t("vehicle.carNo"),
										this.$t("driver.speeding") + this.$t("driver.order"), this.$t(
											"driver.speeding_time"), this.$t("driver.speeding_proportion"),
										this.$t("driver.idleAirConditioning") + this.$t("driver.order"),
										this.$t("driver.idleAirConditioning_time"), this.$t(
											"driver.idleAirConditioning_proportion"),
										this.$t("driver.engineOverturning") + this.$t("driver.order"), this
										.$t("driver.engineOverturning_time"), this.$t(
											"driver.engineOverturning_proportion"),
										this.$t("driver.excessiveIdleSpeed") + this.$t("driver.order"),
										this.$t("driver.excessiveIdleSpeed_time"), this.$t(
											"driver.excessiveIdleSpeed_proportion"),
										this.$t("driver.rapidAcceleration") + this.$t("driver.order"), this
										.$t("driver.rapidAcceleration_time"), this.$t(
											"driver.rapidAcceleration_proportion"),
										this.$t("driver.rapidDeceleration") + this.$t("driver.order"), this
										.$t("driver.rapidDeceleration_time"), this.$t(
											"driver.rapidDeceleration_proportion"),
										this.$t("driver.coasting") + this.$t("driver.order"), this.$t(
											"driver.coasting_time"), this.$t("driver.coasting_proportion"),
										// ,this.$t("driver.clutchLinkage")+this.$t("driver.order"), this.$t("driver.clutchLinkage_time"), this.$t("driver.clutchLinkage_proportion"),
										this.$t("driver.fatigueDriving") + this.$t("driver.order"), this
										.$t("driver.fatigueDriving_time"), this.$t(
											"driver.fatigueDriving_proportion")
									];
									const filterVal = ["carNo", "speeding", "speeding_time",
										"speeding_proportion",
										"idleAirConditioning", "idleAirConditioning_time",
										"idleAirConditioning_proportion",
										// "secondGearStarting", "secondGearStarting_time", "secondGearStarting_proportion", 
										"engineOverturning", "engineOverturning_time",
										"engineOverturning_proportion",
										"excessiveIdleSpeed", "excessiveIdleSpeed_time",
										"excessiveIdleSpeed_proportion",
										"rapidAcceleration", "rapidAcceleration_time",
										"rapidAcceleration_proportion",
										"rapidDeceleration", "rapidDeceleration_time",
										"rapidDeceleration_proportion",
										"coasting", "coasting_time", "coasting_proportion",
										// "coldDriving", "coldDriving_time", "coldDriving_proportion", 
										// "clutchLinkage", "clutchLinkage_time", "clutchLinkage_proportion", 
										"fatigueDriving", "fatigueDriving_time",
										"fatigueDriving_proportion"
									]
									// "dragGear", "dragGear_time", "dragGear_proportion"]
									const list = JSON.parse(JSON.stringify(res.data))
									const data = this.formatJson(filterVal, list)
									excel.export_json_to_excel({
										header: tHeader,
										data,
										filename: fileName,
										autoWidth: this.autoWidth,
										bookType: this.bookType
									})
								})


							}
						})
						.catch((e) => {

						})
				} else {
					this.$message({
						message: this.$t("statistics.PleQuery")
					});
				}
			},
			formatJson(filterVal, jsonData) {
				return jsonData.map(v => filterVal.map(j => {
					switch (j) {
						case "speeding_time":
							return this.timeChange(v[j]);
						case "idleAirConditioning_time":
							return this.timeChange(v[j]);
						case "engineOverturning_time":
							return this.timeChange(v[j]);
						case "excessiveIdleSpeed_time":
							return this.timeChange(v[j]);
						case "rapidAcceleration_time":
							return this.timeChange(v[j]);
						case "rapidDeceleration_time":
							return this.timeChange(v[j]);
						case "coasting_time":
							return this.timeChange(v[j]);
						case "fatigueDriving_time":
							return this.timeChange(v[j]);
						case "speeding_proportion":
							return this.toPercentage(v[j]);
						case "idleAirConditioning_proportion":
							return this.toPercentage(v[j]);
						case "engineOverturning_proportion":
							return this.toPercentage(v[j]);
						case "excessiveIdleSpeed_proportion":
							return this.toPercentage(v[j]);
						case "rapidAcceleration_proportion":
							return this.toPercentage(v[j]);
						case "rapidDeceleration_proportion":
							return this.toPercentage(v[j]);
						case "coasting_proportion":
							return this.toPercentage(v[j]);
						case "fatigueDriving_proportion":
							return this.toPercentage(v[j]);
						default:
							return v[j] == null ? 0 : v[j];
					}
				}))
			},
			initChart() {
				
				this.driverChartByTime = echarts.init(document.getElementById("driverChartByTime"));
				this.driverChartByFrequency = echarts.init(document.getElementById("driverChartByFrequency"));
				var optionByFrequency = {
					title: {
						text: this.$t("driver.byFrequency"),
						left: 'center'
					},
					tooltip: {
						trigger: 'item',
					},
					series: [{
						type: 'pie',
						radius: '50%',
						data: [],
						minAngle: 1,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						},
					}]
				};
				var optionByTime = {
					title: {
						text: this.$t("driver.byTime"),
						left: 'center'
					},
					tooltip: {
						trigger: 'item'
					},
					// legend: {
					//     orient: 'vertical',
					//     left: 'left'
					// },
					series: [{
						type: 'pie',
						radius: '50%',
						data: [],
						minAngle: 1,
						emphasis: {
							itemStyle: {
								shadowBlur: 10,
								shadowOffsetX: 0,
								shadowColor: 'rgba(0, 0, 0, 0.5)'
							}
						}
					}]
				};
				this.driverChartByTime.setOption(optionByTime);
				this.driverChartByFrequency.setOption(optionByFrequency);
			},
			setResize() {
				this.driverChartByTime.resize();
				this.driverChartByFrequency.resize();
			}
		},
		mounted() {
			this.initChart();
			window.addEventListener('resize', this.setResize);
			this.setResize();

			for (var item = 0; item < this.appVehicles.data.length; item++) {
				if (this.appVehicles.data[item].treeLevel == 5) {
					// i++;
					this.allVehicles = this.allVehicles + this.appVehicles.data[item].nodeValue + ",";
				}
			}
			this.allVehicles = this.allVehicles.substring(0, this.allVehicles.length - 1);
		},
		destroyed() {
			window.removeEventListener('resize', this.setResize)
		},
	}
</script>

<style lang="scss" scoped>
	.page_container_a {
		overflow-x: auto;
		overflow-y: auto;
		max-height: calc(100vh - 200px);
		padding: 0 16px; // 左右留白，避免滚动条贴边
		margin-top: 16px;
		::v-deep .el-table {
			background: rgb(244, 248, 255);
			width: auto !important; 
		}

		::v-deep .el-table tr,
		::v-deep .el-table td {
			background: rgb(244, 248, 255);
		}

		// 优化滚动条样式（可选，让滚动条更明显）
		::-webkit-scrollbar {
			width: 8px; // 纵向滚动条宽度
			height: 8px; // 横向滚动条高度
		}

		::-webkit-scrollbar-thumb {
			background: #5b8ddd;
			border-radius: 4px;
		}

		::-webkit-scrollbar-track {
			background: #eee;
		}
	}

	.chart-container {
		padding: 0 16px; // 左右留白，避免图表贴边
		margin-top: 20px;

		// 确保 el-row/el-col 布局生效
		::v-deep .el-row {
			width: 100%;
			margin: 0;
		}

		::v-deep .el-col {
			padding: 0;
			height: 275px; // 与图表高度一致，避免容器塌陷
		}
	}
</style>